import { render, staticRenderFns } from "./CreateTruckPage1.vue?vue&type=template&id=5660db41&scoped=true&"
import script from "./CreateTruckPage1.vue?vue&type=script&lang=js&"
export * from "./CreateTruckPage1.vue?vue&type=script&lang=js&"
import style0 from "./CreateTruckPage1.vue?vue&type=style&index=0&id=5660db41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660db41",
  null
  
)

export default component.exports